"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBitMoveLegal = void 0;
const blockwise_1 = require("blockwise");
function isBitMoveLegal(puzzle, candidate) {
    if (!(0, blockwise_1.isBlockIncluding)(puzzle.block, candidate.block)) {
        return false;
    }
    for (const bit of puzzle.bits) {
        if (bit.id !== candidate.id && (0, blockwise_1.isBlockColliding)(bit.block, candidate.block)) {
            return false;
        }
        if (bit.id === candidate.id && (0, blockwise_1.isBlockEqual)(bit.block, candidate.block)) {
            return false;
        }
    }
    if ((0, blockwise_1.isBlockColliding)(puzzle.latch.block, candidate.block)) {
        return false;
    }
    return true;
}
exports.isBitMoveLegal = isBitMoveLegal;
